(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-bundle-shopping"]) return;
  try {
    
(() => {
  const start = () => {
    const intro = document.querySelector('[data-bundle-shopping]');
    const listing = document.querySelector('#MainContent.av-bundle-shopping-page .bndlr-bundle-listing-container');
    if (!intro || !listing || listing.dataset.avShoppingStarted) return;
    listing.dataset.avShoppingStarted = 'true';
    const label = (key, count) => (intro.dataset[key] || '').replace('[count]', String(count));
    const refresh = () => {
      const panels = Array.from(listing.children).filter(el => el.matches('.bundler-target-element'));
      const featured = panels.find(el => el.dataset.bundle === intro.dataset.featuredBundle);
      if (featured && listing.firstElementChild !== featured) listing.prepend(featured);
      panels.forEach(panel => {
        const title = panel.querySelector('.bndlr-bundle-title');
        const row = panel.querySelector('.bndlr-inner-products-container > div:first-child');
        const products = row ? Array.from(row.children).filter(el => el.matches('.bndlr-product')) : [];
        if (!title || !products.length) return;
        panel.classList.toggle('av-bundle-featured', panel === featured);
        let meta = panel.querySelector('.av-bundle-meta');
        if (!meta) {
          meta = document.createElement('div');
          meta.className = 'av-bundle-meta';
          title.before(meta);
        }
        const countText = label('countLabel', products.length);
        const metaText = (panel === featured ? intro.dataset.featuredLabel + ' · ' : '') + countText;
        if (meta.textContent !== metaText) meta.textContent = metaText;
        const fullTitle = title.textContent.trim();
        if (title.dataset.avTitle !== fullTitle) {
          const parts = fullTitle.match(/^(.*?)\s*[—–-]\s*(Save\s+\d+(?:\.\d+)?%)\s*$/i);
          if (parts) {
            const name = document.createElement('span');
            const saving = document.createElement('span');
            name.className = 'av-bundle-name';
            saving.className = 'av-bundle-saving';
            name.textContent = parts[1];
            saving.textContent = parts[2];
            const separator = document.createElement('span');
            separator.className = 'visually-hidden';
            separator.textContent = ' — ';
            title.replaceChildren(name, separator, saving);
          }
          title.dataset.avTitle = title.textContent.trim();
        }
        row.style.setProperty('--av-project-count', String(Math.min(products.length, 5)));
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', countText);
        let hint = panel.querySelector('.av-bundle-swipe');
        if (!hint) {
          hint = document.createElement('p');
          hint.className = 'av-bundle-swipe';
          row.after(hint);
        }
        const hintText = label('swipeLabel', products.length);
        if (hint.textContent !== hintText) hint.textContent = hintText;
      });
    };
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; refresh(); });
    }).observe(listing, { childList:true, subtree:true, characterData:true });
    refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-plan-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('av-plan-preview')) {
  customElements.define('av-plan-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.previewBound) return;
      this.previewBound = true;
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const media = this.querySelector('[data-plan-preview-media]');
      const title = this.querySelector('[data-plan-preview-title]');
      let trigger = null;
      this.querySelectorAll('[data-plan-preview-open]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const template = document.getElementById(link.dataset.planPreviewOpen);
          if (!template) return;
          event.preventDefault();
          trigger = link;
          title.textContent = link.dataset.previewTitle;
          media.replaceChildren(template.content.cloneNode(true));
          const image = media.querySelector('img');
          if (image) image.loading = 'eager';
          dialog.showModal();
        });
      });
      this.querySelector('[data-plan-preview-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        media.replaceChildren();
        if (trigger && trigger.isConnected) trigger.focus();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["av-video-tutorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('av-project-tutorial')) {
  customElements.define('av-project-tutorial', class extends HTMLElement {
    connectedCallback() {
      if (this.handlePlay) return;
      this.handlePlay = (event) => {
        const trigger = event.target.closest('[data-video-trigger]');
        if (!trigger || !this.contains(trigger)) return;
        const media = this.querySelector('.av-tutorial__media');
        const template = this.querySelector('template');
        const source = template?.content.querySelector('iframe');
        if (!media || !source) return;
        event.preventDefault();
        let player = media.querySelector('iframe');
        if (!player) {
          player = source.cloneNode(true);
          media.replaceChildren(player);
        }
        player.focus();
      };
      this.addEventListener('click', this.handlePlay);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.handlePlay);
      this.handlePlay = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
